import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { Component, Input, WritableSignal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { LanguageCode } from '../../models/language-code';
import { langCodeToIntlFEData } from '../../models/languages-fe-model';
import { LocalizationService } from '../../services/localization.service';
import { LanguageSelectComponent } from '../language-select/language-select.component';

@Component({
    selector: 'apcam-language-selection',
    templateUrl: './language-selection.component.html',
    styleUrls: ['./language-selection.component.scss'],
    imports: [
        CdkOverlayOrigin,
        LanguageSelectComponent,
        MatButtonModule,
        TranslatePipe,
    ],
})
export class LanguageSelectionComponent {
    protected isOpen: boolean = false;

    @Input({ required: true })
    public availableLanguages!: WritableSignal<LanguageCode[]>;

    constructor(private readonly localizationService: LocalizationService) {}

    /**
     * @returns The currently selected language from the translation service.
     */
    protected getCurrentLang(): LanguageCode {
        return this.localizationService.getCurrentLanguage() as LanguageCode;
    }

    /**
     * Maps a language code to a corresponding country code for icon representation.
     *
     * @param lang The language code to map to a country code.
     * @returns The corresponding country code for the given language.
     */
    protected mapLangToCountry(lang: LanguageCode): string {
        return langCodeToIntlFEData.get(lang)?.flagCode ?? '';
    }
}
